import { render, staticRenderFns } from "./BuilderAnnotationTool.vue?vue&type=template&id=40205818&scoped=true&"
import script from "./BuilderAnnotationTool.vue?vue&type=script&lang=js&"
export * from "./BuilderAnnotationTool.vue?vue&type=script&lang=js&"
import style0 from "./BuilderAnnotationTool.vue?vue&type=style&index=0&id=40205818&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40205818",
  null
  
)

export default component.exports